export enum StatusBadgeColor {
  green = 'green',
  yellow = 'yellow',
  red = 'red',
  blue = 'blue',
  grey = 'grey',
}
